function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }

function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }

function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

/*!
  * PhotoSwipe Dynamic Caption plugin 1.2.7 - https://photoswipe.com
  * (c) 2022 Dmytro Semenov
  */
var t = {
  captionContent: ".pswp-caption-content",
  type: "auto",
  horizontalEdgeThreshold: 20,
  mobileCaptionOverlapRatio: .3,
  mobileLayoutBreakpoint: 600,
  verticallyCenterImage: !1
};

var i = /*#__PURE__*/function () {
  function i(_i, e) {
    var _this = this;

    _classCallCheck(this, i);

    this.options = _objectSpread(_objectSpread({}, t), e), this.lightbox = _i, this.lightbox.on("init", function () {
      _this.pswp = _this.lightbox.pswp, _this.initCaption();
    });
  }

  _createClass(i, [{
    key: "initCaption",
    value: function initCaption() {
      var _this2 = this;

      var t = this.pswp;
      t.on("change", function () {
        _this2.showCaption(_this2.pswp.currSlide);
      }), t.on("calcSlideSize", function (t) {
        return _this2.onCalcSlideSize(t);
      }), t.on("slideDestroy", function (t) {
        t.slide.dynamicCaption && (t.slide.dynamicCaption.element && t.slide.dynamicCaption.element.remove(), delete t.slide.dynamicCaption);
      }), t.on("zoomPanUpdate", function (_ref) {
        var _i2 = _ref.slide;

        if (t.opener.isOpen && _i2.dynamicCaption) {
          if (_i2.currZoomLevel > _i2.zoomLevels.initial ? _this2.hideCaption(_i2) : _this2.showCaption(_i2), _i2.dynamicCaption.element) {
            var _t = 0;

            if (_i2.currZoomLevel <= _i2.zoomLevels.initial) {
              var e = _i2.pan.y - _i2.bounds.center.y;
              Math.abs(e) > 1 && (_t = e);
            }

            _this2.setCaptionYOffset(_i2.dynamicCaption.element, _t);
          }

          _this2.adjustPanArea(_i2, _i2.currZoomLevel);
        }
      }), t.on("beforeZoomTo", function (_i3) {
        _this2.adjustPanArea(t.currSlide, _i3.destZoomLevel);
      }), t.on("tapAction", function (t) {
        t.originalEvent.target.closest(".pswp__dynamic-caption") && t.preventDefault();
      });
    }
  }, {
    key: "adjustPanArea",
    value: function adjustPanArea(t, _i4) {
      t.dynamicCaption && t.dynamicCaption.adjustedPanAreaSize && (_i4 > t.zoomLevels.initial ? (t.panAreaSize.x = t.dynamicCaption.originalPanAreaSize.x, t.panAreaSize.y = t.dynamicCaption.originalPanAreaSize.y) : (t.panAreaSize.x = t.dynamicCaption.adjustedPanAreaSize.x, t.panAreaSize.y = t.dynamicCaption.adjustedPanAreaSize.y));
    }
  }, {
    key: "useMobileLayout",
    value: function useMobileLayout() {
      var t = this.options.mobileLayoutBreakpoint;
      return "function" == typeof t ? t.call(this) : "number" == typeof t && window.innerWidth < t;
    }
  }, {
    key: "hideCaption",
    value: function hideCaption(t) {
      if (t.dynamicCaption && !t.dynamicCaption.hidden) {
        var _i15 = t.dynamicCaption.element;
        if (!_i15) return;
        t.dynamicCaption.hidden = !0, _i15.classList.add("pswp__dynamic-caption--faded"), t.captionFadeTimeout && clearTimeout(t.captionFadeTimeout), t.captionFadeTimeout = setTimeout(function () {
          _i15.style.visibility = "hidden", delete t.captionFadeTimeout;
        }, 400);
      }
    }
  }, {
    key: "setCaptionYOffset",
    value: function setCaptionYOffset(t, _i6) {
      t.style.transform = "translateY(".concat(_i6, "px)");
    }
  }, {
    key: "showCaption",
    value: function showCaption(t) {
      if (t.dynamicCaption && t.dynamicCaption.hidden) {
        var _i16 = t.dynamicCaption.element;
        if (!_i16) return;
        t.dynamicCaption.hidden = !1, _i16.style.visibility = "visible", clearTimeout(t.captionFadeTimeout), t.captionFadeTimeout = setTimeout(function () {
          _i16.classList.remove("pswp__dynamic-caption--faded"), delete t.captionFadeTimeout;
        }, 50);
      }
    }
  }, {
    key: "setCaptionPosition",
    value: function setCaptionPosition(t, _i8, e) {
      var s = _i8 <= this.options.horizontalEdgeThreshold;
      t.classList[s ? "add" : "remove"]("pswp__dynamic-caption--on-hor-edge"), t.style.left = _i8 + "px", t.style.top = e + "px";
    }
  }, {
    key: "setCaptionWidth",
    value: function setCaptionWidth(t, _i9) {
      _i9 ? t.style.width = _i9 + "px" : t.style.removeProperty("width");
    }
  }, {
    key: "setCaptionType",
    value: function setCaptionType(t, _i10) {
      var e = t.dataset.pswpCaptionType;
      _i10 !== e && (t.classList.add("pswp__dynamic-caption--" + _i10), t.classList.remove("pswp__dynamic-caption--" + e), t.dataset.pswpCaptionType = _i10);
    }
  }, {
    key: "updateCaptionPosition",
    value: function updateCaptionPosition(t) {
      if (!t.dynamicCaption || !t.dynamicCaption.type || !t.dynamicCaption.element) return;
      if ("mobile" === t.dynamicCaption.type) return this.setCaptionType(t.dynamicCaption.element, t.dynamicCaption.type), t.dynamicCaption.element.style.removeProperty("left"), t.dynamicCaption.element.style.removeProperty("top"), void this.setCaptionWidth(t.dynamicCaption.element, !1);
      var _i11 = t.zoomLevels.initial,
          e = Math.ceil(t.width * _i11),
          s = Math.ceil(t.height * _i11);
      this.setCaptionType(t.dynamicCaption.element, t.dynamicCaption.type), "aside" === t.dynamicCaption.type ? (this.setCaptionPosition(t.dynamicCaption.element, t.bounds.center.x + e, t.bounds.center.y), this.setCaptionWidth(t.dynamicCaption.element, !1)) : "below" === t.dynamicCaption.type && (this.setCaptionPosition(t.dynamicCaption.element, t.bounds.center.x, t.bounds.center.y + s), this.setCaptionWidth(t.dynamicCaption.element, e));
    }
  }, {
    key: "onCalcSlideSize",
    value: function onCalcSlideSize(t) {
      var _i12 = t.slide;
      var e, s;

      if (!_i12.dynamicCaption) {
        _i12.dynamicCaption = {
          element: void 0,
          type: !1,
          hidden: !1
        };

        var _t2 = this.getCaptionHTML(_i12);

        if (!_t2) return;
        _i12.dynamicCaption.element = document.createElement("div"), _i12.dynamicCaption.element.className = "pswp__dynamic-caption pswp__hide-on-close", _i12.dynamicCaption.element.innerHTML = _t2, this.pswp.dispatch("dynamicCaptionUpdateHTML", {
          captionElement: _i12.dynamicCaption.element,
          slide: _i12
        }), _i12.holderElement.appendChild(_i12.dynamicCaption.element);
      }

      if (!_i12.dynamicCaption.element) return;
      this.storeOriginalPanAreaSize(_i12), _i12.bounds.update(_i12.zoomLevels.initial), this.useMobileLayout() ? (_i12.dynamicCaption.type = "mobile", s = !0) : "auto" === this.options.type ? _i12.bounds.center.x > _i12.bounds.center.y ? _i12.dynamicCaption.type = "aside" : _i12.dynamicCaption.type = "below" : _i12.dynamicCaption.type = this.options.type;
      var o = Math.ceil(_i12.width * _i12.zoomLevels.initial),
          n = Math.ceil(_i12.height * _i12.zoomLevels.initial);

      if (this.setCaptionType(_i12.dynamicCaption.element, _i12.dynamicCaption.type), "aside" === _i12.dynamicCaption.type) {
        this.setCaptionWidth(_i12.dynamicCaption.element, !1), e = this.measureCaptionSize(_i12.dynamicCaption.element, t.slide);

        var _s = e.x,
            _n = o + _i12.bounds.center.x;

        _i12.panAreaSize.x - _n <= _s && (_i12.panAreaSize.x -= _s, this.recalculateZoomLevelAndBounds(_i12));
      } else if ("below" === _i12.dynamicCaption.type || s) {
        this.setCaptionWidth(_i12.dynamicCaption.element, s ? this.pswp.viewportSize.x : o), e = this.measureCaptionSize(_i12.dynamicCaption.element, t.slide);
        var a = e.y;
        if (this.options.verticallyCenterImage) _i12.panAreaSize.y -= a, this.recalculateZoomLevelAndBounds(_i12);else {
          var _t3 = n + _i12.bounds.center.y,
              _e = _i12.panAreaSize.y - _t3,
              _o = _i12.panAreaSize.y;

          if (_e <= a) {
            _i12.panAreaSize.y -= Math.min(2 * (a - _e), a), this.recalculateZoomLevelAndBounds(_i12);

            var _t4 = _i12.panAreaSize.x * this.options.mobileCaptionOverlapRatio / 2;

            s && _i12.bounds.center.x > _t4 && (_i12.panAreaSize.y = _o, this.recalculateZoomLevelAndBounds(_i12));
          }
        }
      }

      this.storeAdjustedPanAreaSize(_i12), this.updateCaptionPosition(_i12);
    }
  }, {
    key: "measureCaptionSize",
    value: function measureCaptionSize(t, _i13) {
      var e = t.getBoundingClientRect();
      return this.pswp.dispatch("dynamicCaptionMeasureSize", {
        captionEl: t,
        slide: _i13,
        captionSize: {
          x: e.width,
          y: e.height
        }
      }).captionSize;
    }
  }, {
    key: "recalculateZoomLevelAndBounds",
    value: function recalculateZoomLevelAndBounds(t) {
      t.zoomLevels.update(t.width, t.height, t.panAreaSize), t.bounds.update(t.zoomLevels.initial);
    }
  }, {
    key: "storeAdjustedPanAreaSize",
    value: function storeAdjustedPanAreaSize(t) {
      t.dynamicCaption && (t.dynamicCaption.adjustedPanAreaSize || (t.dynamicCaption.adjustedPanAreaSize = {}), t.dynamicCaption.adjustedPanAreaSize.x = t.panAreaSize.x, t.dynamicCaption.adjustedPanAreaSize.y = t.panAreaSize.y);
    }
  }, {
    key: "storeOriginalPanAreaSize",
    value: function storeOriginalPanAreaSize(t) {
      t.dynamicCaption && (t.dynamicCaption.originalPanAreaSize || (t.dynamicCaption.originalPanAreaSize = {}), t.dynamicCaption.originalPanAreaSize.x = t.panAreaSize.x, t.dynamicCaption.originalPanAreaSize.y = t.panAreaSize.y);
    }
  }, {
    key: "getCaptionHTML",
    value: function getCaptionHTML(t) {
      if ("function" == typeof this.options.captionContent) return this.options.captionContent.call(this, t);
      var _i14 = t.data.element;
      var e = "";

      if (_i14) {
        var _t5 = _i14.querySelector(this.options.captionContent);

        if (_t5) e = _t5.innerHTML;else {
          var _t6 = _i14.querySelector("img");

          _t6 && (e = _t6.getAttribute("alt"));
        }
      }

      return e;
    }
  }]);

  return i;
}();

export { i as default };